import { Button, Grid, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { FormControlStato, GridContainer, Title } from '../../commons/styleds/styleds';
import { DividerMenu } from '../../components/Header';
import { GridItem } from '../../components/Menu';
import { history } from '../../helpers/history';
import { useRedefinirSenhaActions } from '../../states/redefinirSenha/redefinirSenha.actions';
import { DivBackground, TextFieldLogin, TextoBemVindo, Wrapper } from '../Login';
import Logo from './../../assets/STATO-INTOO-LOGO-MY-INTOO-VERS-2 A.png';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Footer from '../../components/Footer';
import { text } from 'node:stream/consumers';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

const SolicitarRedefinicaoSenha: React.FC = () => {
  const { language, translate } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const redefinirSenhaActions = useRedefinirSenhaActions();
  const [email, setEmail] = useState<string>('');
  const [enviado, setEnviado] = useState<boolean>(false);

  const onSubmit = (e: any) => {
    e.preventDefault();

    redefinirSenhaActions.create({ email, origem: 'ASSESSORADO' }).then((resp: any) => {
      toast.success(translate('enviadoComSucesso'));
      setEnviado(true);
    });
  };

  return (
    <>
      <DividerMenu />
      <DivBackground>
        <Wrapper>
          <PaperRedefinirSenha>
            <img src={Logo} alt="logo" style={{ width: 'auto', height: '80px' }} />

            {enviado ? (
              <>
                <Typography variant="h5">{translate('mensagemEnviada')}</Typography>
                <Link to="/login" style={{ marginTop: '20px' }}>
                  {translate('voltarInicio')}
                </Link>
              </>
            ) : (
              <>
                <Typography variant="h5">{translate('recuperacaoDeSenha')}</Typography>

                <Typography variant="body2" sx={{ textAlign: 'center', marginY: '20px' }}>
                  {translate('recuperacaoDeSenhaDescricao')}
                </Typography>

                <form onSubmit={onSubmit} style={{ marginTop: '20px' }}>
                  <FormControlStato sx={{ width: '100%', marginBottom: '12px' }} variant="filled">
                    <TextFieldLogin
                      id="filled-basic"
                      type="email"
                      placeholder={translate("email")}
                      required
                      variant="outlined"
                      value={email}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setEmail(event.target.value);
                      }}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <EmailOutlinedIcon />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </FormControlStato>
                  <Button type="submit" variant="contained" fullWidth sx={{ marginTop: '32px' }}>
                    {translate('enviar')}
                  </Button>
                </form>
              </>
            )}
          </PaperRedefinirSenha>
        </Wrapper>
      </DivBackground>
      <Footer />
    </>
  );
};

export const PaperRedefinirSenha = styled(Paper)`
  width: 400px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);

  @media (max-width: 576px) {
    width: 312px;
  }
`;

export const TitleLogin = styled(Title)`
  color: white;
  text-align: center;
  @media (max-width: 900px) {
    color: var(--black);
  }
`;

export default SolicitarRedefinicaoSenha;
